export default {"src":"https://cloudflare.edhrec.com/_next/static/media/manaurw.7b7314ec.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};